import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";

export const FILTER_ENTITY_TYPES = ["universal", ...MAP_ENTITY_TYPES] as MapFilterEntityType[];
